import React from "react";
import { Route, Redirect } from "react-router-dom";
import AllModels from "../pages/Common/AllModels";

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (isAuthProtected && !localStorage.getItem("access_token")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      } else if (!isAuthProtected) {
        return (
          <Layout>
            <React.Suspense fallback={<div />}>
              <Component {...props} />
            </React.Suspense>
          </Layout>
        );
      } else {
        return (
          <Layout>
            <React.Suspense fallback={<div />}>
              <Component {...props} />
              <AllModels {...props} />
            </React.Suspense>
          </Layout>
        );
      }
    }}
  />
);

export default AppRoute;
